<template>
  <div class="modal reg-modal page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="container">
            <div class="form">
              <div class="form-wrapper">
                <div class="form-fields register-content">
                  <div class="title">
                    {{ $t("CREATE ACCOUNT") }}
                  </div>
                  <div class="form-fields-wrapper">
                    <label>
                      <div class="desc">{{ $t("*First name") }}</div>
                      <input
                        type="text"
                        :placeholder="$t('First name')"
                        v-model="name"
                      />
                    </label>
                    <label>
                      <div class="desc">{{ $t("*Last Name") }}</div>
                      <input
                        type="text"
                        :placeholder="$t('Last Name')"
                        v-model="surname"
                      />
                    </label>
                    <label>
                      <div class="desc">{{ $t("*Email") }}</div>
                      <input
                        type="email"
                        :placeholder="$t('Email')"
                        v-model="email"
                      />
                    </label>
                    <label>
                      <div class="desc">{{ $t("*Phone") }}</div>
                      <input
                        type="tel"
                        :placeholder="$t('Phone')"
                        v-model="phone"
                      />
                    </label>
                    <label>
                      <div class="desc">{{ $t("*Password") }}</div>
                      <input
                        type="password"
                        :placeholder="$t('Password')"
                        v-model="pass"
                      />
                    </label>
                    <label>
                      <div class="desc">{{ $t("*Confirm Password") }}</div>
                      <input
                        type="password"
                        :placeholder="$t('Confirm Password')"
                        v-model="passConfirm"
                      />
                    </label>
                    <div class="cta-container">
                      <div class="chekbox-container">
                        <label class="chekbox-label">
                          <div class="chekbox-label-wrapper">
                            <input
                              type="checkbox"
                              name="terms"
                              v-model="terms"
                            />
                            <div class="checkbox"></div>
                            <span class="desc">{{ $t("I agree with") }} </span>
                            <a
                              @click="$parent.goToPage('privacy')"
                              class="desc"
                              >{{ $t("privacy policy") }}</a
                            >
                            <span class="desc"> {{ $t("and") }} </span>
                            <a
                              @click="$parent.goToPage('terms')"
                              class="desc"
                              >{{ $t("terms and conditions") }}</a
                            >
                          </div>
                        </label>
                      </div>
                      <button
                        :class="[
                          'button',
                          { disabled: !requiredRegisterFieldsAreFilled },
                        ]"
                        @click="submitRegister"
                      >
                        <span>{{ $t("Sign up") }}</span>
                      </button>
                    </div>
                    <transition name="slide">
                      <div v-if="$parent.error" class="error-desc desc red">
                        {{ $parent.error }}
                      </div>
                    </transition>
                  </div>
                </div>
                <div class="modal-bottom">
                  <div class="title">{{ $t("Have an account?") }}</div>
                  <div class="desc">
                    {{ $t("Please login with your personal info") }}
                  </div>
                  <div class="button switch-login" @click="$parent.openSignIn">
                    {{ $t("Sign In") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Registration",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      pass: "",
      name: "",
      surname: "",
      phone: "",
      passConfirm: "",
      terms: false,
    };
  },
  mounted() {},
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        this.pass &&
        this.passConfirm &&
        this.terms
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  methods: {
    submitRegister() {
      let regData = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        password: this.pass,
        passConfirm: this.passConfirm,
      };
      this.$emit("registration", regData);
    },
  },
};
</script>
